/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useState } from 'react';

import type { ExternalFormApi, FormErrors } from '../interfaces';

export const useExternalFormApi = <V, >(): ExternalFormApi<V> => {
    const [formApi] = useState(() => ({
        setValue: (pathOrValue: string | V, value: any) => {
            throw Error('Don\'t call the setValue method synchronously from a component. Use it in event handlers or effect hooks.');
        },
        isValid: (): boolean => {
            throw Error('Don\'t call the isValid method synchronously from a component. Use it in event handlers or effect hooks.');
        },
        isDataChanged: (): boolean => {
            throw Error('Don\'t call the isDataChanged method synchronously from a component. Use it in event handlers or effect hooks.');
        },
        submit: (): void => {
            throw Error('Don\'t call the submit method synchronously from a component. Use it in event handlers or effect hooks.');
        },
        getExternalErrors: (): FormErrors<V> => {
            throw Error('Don\'t call the getExternalErrors method synchronously from a component. Use it in event handlers or effect hooks.');
        },
        setExternalErrors: (errors: FormErrors<V>): void => {
            throw Error('Don\'t call the setExternalErrors method synchronously from a component. Use it in event handlers or effect hooks.');
        },
        validate: (): boolean => {
            throw Error('Don\'t call the isValid method synchronously from a component. Use it in event handlers or effect hooks.');
        },
        value: null,
    }));

    return formApi;
};
